import { gql } from '@apollo/client';

export default gql`
  query spaceUsers($page: Int, $name: String, $email: String) {
    spaceUsers(page: $page, name: $name, email: $email) {
      hasNextPage
      usersTotalPages
      usersTotal
      currentPage
      users {
        id
        email
        name
        surname
      }
    }
  }
`;
